<script>
  import Section from "$components/Section.svelte";
  import siteData from "$data/site_content.aml";
  import { onMount } from "svelte";
  import { createData } from "$utils/data.svelte.js";
  import { Block } from "@urbaninstitute/dataviz-components";
  import { getAbsoluteUrl } from "$utils/urls.js";
  import Chart from "./Chart.svelte";

  let width = $state(240);

  let toolData = createData();

  onMount(async () => {
    toolData.fetchData();
  });
</script>

<svelte:window bind:innerWidth={width} />
<main>
  {#if Object.values(siteData).length > 0}
  <Block width={width > 1160 ? "wide" : "body"}>
  <div class="rule"></div>
  </Block>

    {#each Object.values(siteData).filter((d) => d.sectionType == "content") as sectionData, i}
      {#if i != 0 && width > 1160}
        <div style="height: 240px"></div>
      {/if}
      <Section {sectionData} />
    {/each}
    <div style="height:100px;"></div>
  {/if}
</main>

<style>
  main {
    width: 100%;
    max-width: 1160px;
    margin: 0 auto;
  }
  .rule{
    width: 100%;
    height: 1px;
    margin-top: 100px;
    margin-bottom: 86px;
    background-color: var(--color-gray-shade-dark);
  }
</style>
